export type CancellationFeeType = 'NO_SHOW' | 'LATE_CANCELLATION';

export const cancellationFeeTypeLabels: Record<CancellationFeeType, string> = {
    NO_SHOW: 'No-Show',
    LATE_CANCELLATION: 'Kurzfristige Absage',
};

export const cancellationFeeAppointmentStatusLabels: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
    CANCELLED: { label: 'Abgesagt', variant: 'secondary' },
    NO_SHOW: { label: 'Nicht erschienen', variant: 'destructive' },
};

export const formatDurationRange = (minDurationMinutes: number, maxDurationMinutes: number | null) =>
    maxDurationMinutes === null
        ? `ab ${minDurationMinutes} Min.`
        : `${minDurationMinutes}–${maxDurationMinutes} Min.`;

/**
 * Cancellation fees can only be created once the appointment's last step has ended (enforced by the server).
 */
export const hasAppointmentEnded = (endDate: string | Date | null | undefined) =>
    !!endDate && new Date(endDate).getTime() <= Date.now();

export const formatEur = (amount: number) =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
